import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const instance = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Fallback bearer token (for browsers that block 3rd-party cookies)
instance.interceptors.request.use((config) => {
  const token = localStorage.getItem("bb_token");
  if (token) {
    config.headers = config.headers || {};
    if (!config.headers.Authorization) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  }
  return config;
});

export function fileUrl(path) {
  if (!path) return null;
  return `${API}/files/${path}`;
}

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .join(" ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default instance;
